import { DataSourceType } from 'automation-ui-formula-editor/data-passing-panel/types/dataSourcesTypes';
import { ENROLLED_OBJECT } from 'automation-ui-formula-editor/data-sources/constants/dataSourcesConstants';

// TODO: WRITE UNIT TESTS FOR THIS
export function getToObjectType(dataSourceDefinition, enrolledObjectTypeId) {
  let toObjectTypeId = '';
  if (!dataSourceDefinition || !dataSourceDefinition.metadata) {
    return toObjectTypeId;
  }
  if (dataSourceDefinition.name === ENROLLED_OBJECT) {
    toObjectTypeId = enrolledObjectTypeId;
    return toObjectTypeId;
  }
  if (dataSourceDefinition.dataSourceType === DataSourceType.FETCHED_OBJECT) {
    const metadata = dataSourceDefinition.metadata;
    if ('associationDefinition' in metadata) {
      const {
        associationDefinition
      } = metadata || {
        toObjectTypeId: ''
      };
      toObjectTypeId = associationDefinition.toObjectTypeId || '';
      return toObjectTypeId;
    } else if ('recordFilterDefinition' in metadata) {
      return metadata.objectTypeId;
    }
  }
  return toObjectTypeId;
}